import {
  GoogleIcon_default
} from "./chunk-2KKAEMTT.mjs";
export {
  GoogleIcon_default as default
};
